
<template>
  <div  class="vx-row">
   <div class="vx-col  md:w-1/1 ml-auto mr-auto w-full mb-base">
      <vx-card title="">
         
        <div class="vx-row" >
            <div class="vx-col w-full md:w-1/2">
                <vx-card>
                 
                    <div class="p-8 clearfix" style="text-align:-moz-center">

                     <div >
                      <img src="/img/avatar-s-11.7b75d719.png" alt=""
                        class="rounded-full shadow-md cursor-pointer block" width="160" height="160">
                      </div><br>
                            <h3>Diego Armando Olvera Luna</h3>
                      <div>
                        <vs-progress :height="3" :percent="100" color="danger"></vs-progress>
                      </div>
                    </div>
                
                </vx-card>
            </div>
            <div class="vx-col w-full md:w-1/2">
                <vx-card title="Pagos">
                  <template slot="no-body">
                    <div class="p-8 clearfix">
                      <vs-table :data="users">
                        <template slot="thead">
                          <vs-th>NO</vs-th>
                          <vs-th>FECHA DE PAGO</vs-th>
                          <vs-th>MONTO</vs-th>
                        </template>
                        <template slot-scope="{data}">
                          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].id">
                              {{ data[indextr].id }}
                            </vs-td>
                            <vs-td :data="data[indextr].fecha">
                              {{ data[indextr].fecha }}
                            </vs-td>
                           <vs-td :data="data[indextr].monto">
                              {{ data[indextr].monto }}
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </template>
                </vx-card>
            </div>
        </div><br>

        <div class="vx-row" >
            <div class="vx-col w-full md:w-1/2">
                <vx-card title="Ofertas">
                  <template slot="no-body">
                    <div class="p-8 clearfix" style="height: 372px;">
                      <vs-table :data="ofertas">
                        <template slot="thead">
                          <vs-th>NO</vs-th>
                          <vs-th>OFERTA</vs-th>
                          <vs-th></vs-th>
                          
                        </template>
                        <template slot-scope="{data}">
                          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].id">
                              {{ data[indextr].id }}
                            </vs-td>
                            <vs-td :data="data[indextr].oferta">
                              {{ data[indextr].oferta }}
                            </vs-td>
                            <vs-td :data="data[indextr].id">
                            <vs-button size="small">Ver</vs-button>
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </template>
                </vx-card>
            </div>
            <div class="vx-col w-full md:w-1/2">
                <vx-card title="Asistencia">
                  <template slot="no-body">
                    <div class="p-8 clearfix">
                     
                      <div class="vx-col sm:w-4/5 justify-center mx-auto">
                        <vue-apex-charts type=radialBar height=250 :options="supportTrackerRadialBar.chartOptions" 
                          :series="supportTrackerRadialBar.series" />
                      </div>
                    </div>
                     <div class="flex flex-row justify-between px-8 pb-4">
                        <p class="text-center"><span class="block">Asistencias</span><span class="text-4xl">29</span></p>
                        <p class="text-center"><span class="block">Faltas</span><span class="text-4xl">11</span></p>
                    </div>           
                  </template>
                </vx-card>
            </div>
        </div><br>
      </vx-card>
    </div>
  </div>
</template>


<script>
import VueApexCharts from 'vue-apexcharts'


export default{
  data() {
    return {

    users: [
        {
          "id": 1,
          "monto": "2,500.00",
          "fecha": "25 de Abril 2019"
        },
        {
          "id": 2,
         "monto": "2,500.00",
          "fecha": "25 de Abril 2019"
        },
        {
          "id": 3,
          "monto": "2,500.00",
          "fecha": "25 de Abril 2019"
        },
        {
          "id": 4,
          "monto": "2,500.00",
          "fecha": "25 de Abril 2019"
        },
        {
          "id": 5,
          "monto": "2,500.00",
          "fecha": "25 de Abril 2019"
        }
      ],
    ofertas:[
      {
      "id": 1,
      "oferta": "Licenciatura en Programación"          
      },
      {
      "id": 2,
      "oferta": "Licenciatura en Programación"          
      },
      {
      "id": 3,
      "oferta": "Licenciatura en Programación"          
      },
      {
      "id": 3,
      "oferta": "Licenciatura en Programación"          
      },
      ],

    supportTrackerRadialBar: {
        chartData: {
            totalTickets: 163,
            openTickets: 103,
            lastResponse: '1d',
        },
        series: [80],
        chartOptions: {
            plotOptions: {
                radialBar: {
                    size: 150,
                    startAngle: -150,
                    endAngle: 150,
                    hollow: {
                        size: '65%',
                    },
                    track: {
                        background: "#fff",
                        strokeWidth: '100%',

                    },
                    dataLabels: {
                        value: {
                            offsetY: 30,
                            color: '#99a2ac',
                            fontSize: '2rem'
                        }
                    }
                },
            },
            colors: ['#EA5455'],
            fill: {
                type: 'gradient',
                gradient: {
                    // enabled: true,
                    shade: 'dark',
                    type: 'horizontal',
                    shadeIntensity: 0.5,
                    gradientToColors: ['#7367F0'],
                    inverseColors: true,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 100]
                },
            },
            stroke: {
                dashArray: 8
            },
            chart: {
                sparkline: {
                }
            },
            labels: ['Porcentaje de Asistencia'],
        }
    }
  }
},
  components: {
    VueApexCharts,
  }
}
</script>

